module.exports = __webpack_public_path__ + "static/screens-analytics-f870b33cd37cb61a101327d315194dd5.jpg";